var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ChannelWrapper",
    _vm._b({ ref: "wrapper" }, "ChannelWrapper", _vm.$props, false),
    [
      _c("span", { staticClass: "name" }, [_vm._v(_vm._s(_vm.channel.name))]),
      _vm.channel.unread
        ? _c(
            "span",
            {
              staticClass: "badge",
              class: { highlight: _vm.channel.highlight && !_vm.channel.muted },
            },
            [_vm._v(_vm._s(_vm.unreadCount))]
          )
        : _vm._e(),
      _vm.channel.type === "channel"
        ? [
            _vm.channel.state === 0
              ? _c(
                  "span",
                  {
                    staticClass:
                      "parted-channel-tooltip tooltipped tooltipped-w",
                    attrs: { "aria-label": "Not currently joined" },
                  },
                  [_c("span", { staticClass: "parted-channel-icon" })]
                )
              : _vm._e(),
            _c(
              "span",
              {
                staticClass: "close-tooltip tooltipped tooltipped-w",
                attrs: { "aria-label": "Leave" },
              },
              [
                _c("button", {
                  staticClass: "close",
                  attrs: { "aria-label": "Leave" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                }),
              ]
            ),
          ]
        : [
            _c(
              "span",
              {
                staticClass: "close-tooltip tooltipped tooltipped-w",
                attrs: { "aria-label": "Close" },
              },
              [
                _c("button", {
                  staticClass: "close",
                  attrs: { "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                }),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }